import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermissionService } from './user-permission.service';
import { MessageService } from 'common';
import { UserPermissionData } from './user-permission.data';

@UntilDestroy()
@Directive({
    selector: '[ifbUserPermissionGranted]',
    standalone: false
})
export class UserPermissionGrantedDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userPermissionService: UserPermissionService,
    private messageService: MessageService
  ) {}

  @Input('ifbUserPermissionGranted')
  set permissions(permissions: UserPermissionData[]) {
    this.userPermissionService
      .granted(permissions)
      .pipe(untilDestroyed(this))
      .subscribe(
        granted => {
          if (granted && !this.viewCreated) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.viewCreated = true;
          } else if (!granted && this.viewCreated) {
            this.viewContainer.clear();
            this.viewCreated = false;
          }
        },
        error => {
          this.messageService.error(error);
        }
      );
  }

  private viewCreated = false;
}
